/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropTypes from 'prop-types'

import { CircularProgress } from '@mui/material'

import useStyles from 'shared/hooks/useStyle'

import styles from './Loading.styles'

const propTypes = { className: PropTypes.string }

const Loading = (props) => {
    const { className = '' } = props
    const classes = useStyles(styles)

    return (
        <div css={[
            classes.wrapper,
            className,
        ]}
        >
            <CircularProgress {...props} />
        </div>
    )
}

Loading.propTypes = propTypes

export default Loading
